var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgA1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 30,
    viewBox: "0 0 54 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 22279",
    d: "M0.908698 1.5145C0.508783 0.847972 0.988896 0 1.76619 0H44.4338C44.7851 0 45.1106 0.184299 45.2913 0.485504L53.3826 13.971C53.7626 14.6044 53.7626 15.3956 53.3826 16.029L45.2913 29.5145C45.1106 29.8157 44.7851 30 44.4338 30H1.76619C0.988895 30 0.508783 29.152 0.908697 28.4855L8.3826 16.029C8.76262 15.3956 8.76262 14.6044 8.3826 13.971L0.908698 1.5145Z",
    fill: "#7ACA45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA1);
export default __webpack_public_path__ + "static/media/a1.8d98aedaf9cc3cd8b2624009ed2ee029.svg";
export { ForwardRef as ReactComponent };